import { useTranslation } from "react-i18next";

import updateTodo from "astrid-firestore/src/api/todos/updateTodo";
import deleteDocument from "astrid-firestore/src/helpers/deleteDocument";

import { useProfile } from "../../../../authentication/state/profile";
import useHasRight from "../../../../authorization/hooks/useHasRight";

export default function useNotificationDropdownOptions(todo) {
	const { t } = useTranslation();
	const user = useProfile();
	const hasRight = useHasRight();

	const togglePin = (e) => {
		e.stopPropagation();
		e.preventDefault();

		return updateTodo(todo.ref, {
			pinned: {
				status: !todo.pinned?.status,
				user,
			},
		});
	};

	return [
		{
			key: "pin",
			value: "pin",
			text: todo.pinned?.status ? t("unpin", "Unpin") : t("pin", "Pin"),
			onClick: (e) => togglePin(e),
			disabled: (todo.pinned?.status && todo.pinned?.user.id !== user.id) || !hasRight("todos.pin"),
		},
		{
			key: "remove",
			value: "remove",
			text: t("remove", "Remove"),
			onClick: (e) => {
				e.stopPropagation();
				e.preventDefault();

				deleteDocument(todo.ref);
			},
			disabled: todo.pinned?.status,
		},
	];
}
